import * as React from 'react';
import { LogbogAfsnit } from '../../models/LogbogAfsnit';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { TextFormGroup, TextAreaFormGroup } from '../../uiComponents/input/FormGroups';
import { ValidationError, getValidationErrorsForCollection } from '../../infrastructure/ValidationResult';
import { SectionDynamic } from '../../uiComponents/layout/SectionDynamic';

export interface LogbogAfsnitComponentProps {
    logbogAfsnit: LogbogAfsnit;
    index: number;
    removeLogbogAfsnit: (key: any) => void;
    onAfsnitChanged: (fieldName: string, value: any, index: number) => void;
    errorMessages: ValidationError[];
}

class LogbogAfsnitComponent extends React.Component<LogbogAfsnitComponentProps, any> {
    constructor(props: LogbogAfsnitComponentProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(field: string, value: string) {
        this.props.onAfsnitChanged(field, value, this.props.index);
    }

    render() {
        var afsnitErrors = getValidationErrorsForCollection(this.props.errorMessages, 'afsnit', this.props.index);

        return (
            <div>
                <SectionDynamic index={this.props.index} deleteOnClick={() => this.props.removeLogbogAfsnit(this.props.index)}>
                    <Row>
                        <Col md={6} mdOffset={3}>
                            <TextFormGroup
                                errorMessages={afsnitErrors}
                                label='Titel*'
                                name='titel'
                                placeholder='Skriv titel'
                                value={this.props.logbogAfsnit.titel}
                                onChange={this.onChange}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} mdOffset={3}>
                            <TextAreaFormGroup
                                errorMessages={afsnitErrors}
                                label='Beskrivelse'
                                name='beskrivelse'
                                placeholder='Skriv beskrivelse'
                                value={this.props.logbogAfsnit.beskrivelse}
                                onChange={this.onChange}
                            />
                        </Col>
                    </Row>
                </SectionDynamic>
            </div>
        );
    }
}

export default LogbogAfsnitComponent;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Logbog/LogbogAfsnitComponent.tsx